import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { scrollYSlice } from '../../../store/scrollYSlice';
import { useScrollY } from '../../screen/useScrollY';
import { useAppDispatch } from '../useStore';
import { useCropTrendsScrollSave } from './useCropTrendsScrollSave';

export const useStoreScrollY = () => {
  const { pathname } = useLocation();
  const { scrollY } = useScrollY();

  const dispatch = useAppDispatch();
  const scrollYActions = scrollYSlice.actions;

  // 농산물시세 페이지 전용 스크롤 저장 훅 사용
  useCropTrendsScrollSave();

  useEffect(() => {
    if (pathname === pageInfo.homePage.path) {
      dispatch(scrollYActions.changeHomePageScrollY(scrollY));
    } else if (pathname === pageInfo.infoListPage.path) {
      dispatch(scrollYActions.changeInfoListPageScrollY(scrollY));
    } else if (pathname === pageInfo.productListPage.path) {
      dispatch(scrollYActions.changeProductListPageScrollY(scrollY));
    } else if (pathname === pageInfo.openMarketListPage.path) {
      dispatch(scrollYActions.changeOpenMarketListPageScrollY(scrollY));
    } else if (pathname === pageInfo.tractorPokingListPage.path) {
      dispatch(scrollYActions.changeTractorPokingListPageScrollY(scrollY));
    } else if (pathname === '/event-2024-02') {
      dispatch(scrollYActions.changeEvent202402ScrollY(scrollY));
    } else if (pathname === pageInfo.cropTrendsListPage.path) {
      // cropTrendsListPage는 useCropTrendsScrollSave에서 처리
      // 여기서는 아무것도 하지 않음
    }
  }, [pathname, scrollY]);
};
